
import './App.css';
import Navbar from'./Components/navbar.js'
import Content from './Components/Content.js'
import Pumps from './Components/Pumps.js';
function App() {
  return (
    <div >
      <Navbar />
      <Content/>
      <Pumps/>
    </div>
  );
}

export default App;
